var _defs, _path, _path2, _path3, _path4, _polygon, _polygon2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefactoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177.6 36.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#211e1f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.91,36.46H1.13a2.23,2.23,0,0,1-.34,0l-.39,0V.8H.61L3.55.69C4.93.63,6.37.57,7.77.57a27.16,27.16,0,0,1,6.53.67,17.84,17.84,0,0,1-3.68,35.18c-1.1,0-2.28,0-3.71,0Zm.22-2.66H9.84a15.33,15.33,0,0,0,15.38-14c.67-8-5.53-15.56-13.28-16.28-1.54-.14-3.09-.16-4.27-.16H3.08V33.81Z",
    transform: "translate(-0.4 -0.57)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.25,1.45C9.8.36,5.21.91.62,1V36.16a4.07,4.07,0,0,0,.51.07c3.16,0,6.33.07,9.48,0A17.72,17.72,0,0,0,27.52,21.37,17.58,17.58,0,0,0,14.25,1.45ZM25.43,19.8A15.61,15.61,0,0,1,9.59,34c-2.22,0-4.44,0-6.72,0V3.26c.09,0,.14-.11.19-.11,3,0,6-.13,8.9.14C20,4,26.11,11.8,25.43,19.8Z",
    transform: "translate(-0.4 -0.57)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.68,37a14,14,0,1,1-.07-28.06,13.59,13.59,0,0,1,2.7.27A13.85,13.85,0,0,1,58.57,24.13l0,.19H33.44c.12,4,3.65,8.27,8,9.56a10.94,10.94,0,0,0,3.19.46c2.23,0,7.76-.73,10.84-7.48l.09-.19,2.3,1-.07.19A14.08,14.08,0,0,1,44.68,37ZM55.89,21.58a11.34,11.34,0,0,0-11.28-9.95h-.22c-5.6.11-10.66,4.73-11,9.95Z",
    transform: "translate(-0.4 -0.57)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.27,9.42a13.81,13.81,0,1,0,10.3,18.33l-1.92-.81c-3.25,7.12-9.72,8.5-14.29,7.14s-8.13-5.75-8.13-10H58.36A13.64,13.64,0,0,0,47.27,9.42ZM33.21,21.79c.17-5.45,5.41-10.26,11.18-10.37A11.52,11.52,0,0,1,56.12,21.79Z",
    transform: "translate(-0.4 -0.57)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61.36 35.82 61.36 0.17 79.91 0.17 79.91 2.7 64.03 2.7 64.03 15.55 78.88 15.55 78.88 18.16 63.96 18.16 63.96 35.82 61.36 35.82"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61.57 35.61 63.75 35.61 63.75 17.95 78.67 17.95 78.67 15.76 63.82 15.76 63.82 2.49 79.7 2.49 79.7 0.38 61.57 0.38 61.57 35.61"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M95.1,37l-.84,0a13.5,13.5,0,0,1-9.55-4.53,14,14,0,0,1,.69-19.65,14.26,14.26,0,0,1,21,1.83V9.69l0,0V9H109V36.38h-2.57v-.8h0V31.25C103.32,35.1,99.61,37,95.1,37Zm0-25.34A11.37,11.37,0,1,0,103.12,15a11.37,11.37,0,0,0-8.05-3.34v0Z",
    transform: "translate(-0.4 -0.57)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.67,19.36",
    transform: "translate(-0.4 -0.57)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.55,18.31l-.07-.19A14.15,14.15,0,0,0,124.3,9a15.12,15.12,0,0,0-2.32.19A14.15,14.15,0,0,0,110.32,23.1a14.24,14.24,0,0,0,12,13.77,15.75,15.75,0,0,0,1.93.12,14.2,14.2,0,0,0,13.23-9.17l.06-.19-2.29-1-.08.18c-3,6.76-8.62,7.49-10.88,7.49A11.35,11.35,0,0,1,121,12.15a10.63,10.63,0,0,1,3.38-.55,11,11,0,0,1,3.18.48,11.78,11.78,0,0,1,7.56,7l1.62.31Z",
    transform: "translate(-0.4 -0.57)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.13,19.12l.44,0,.26-.34s.16-.23.43-.58h0v0h0a13.8,13.8,0,0,0-26.75,4.91,13.8,13.8,0,0,0,26.75,4.65l-1.92-.81c-3.18,7.06-9.64,8.47-14.21,7.18a11.64,11.64,0,0,1-8.37-10.83A11.45,11.45,0,0,1,120.93,12a11,11,0,0,1,6.68-.08A12.07,12.07,0,0,1,135.3,19h0Z",
    transform: "translate(-0.4 -0.57)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164,37a14,14,0,1,1,14-14A14,14,0,0,1,164,37Zm0-25.4A11.41,11.41,0,1,0,175.42,23,11.42,11.42,0,0,0,164,11.58Z",
    transform: "translate(-0.4 -0.57)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164,9.21A13.78,13.78,0,1,0,177.79,23,13.78,13.78,0,0,0,164,9.21Zm0,25.4A11.63,11.63,0,1,1,175.63,23,11.63,11.63,0,0,1,164,34.61Z",
    transform: "translate(-0.4 -0.57)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.75,37c-.27,0-.5,0-.72-.05l-.17,0a6.79,6.79,0,0,1-3-.92,5.35,5.35,0,0,1-2.07-2.3,8.62,8.62,0,0,1-.64-4.19V12.18l-4.59,0V9.56h4.51V.75h2.75V9.52h6.57v2.62l-6.57,0V29.52a7.92,7.92,0,0,0,.4,2.82,3.13,3.13,0,0,0,1.19,1.53,4.42,4.42,0,0,0,2,.65c.13,0,.45,0,.8,0h.35v2.35l-.18,0A4.89,4.89,0,0,1,147.75,37Z",
    transform: "translate(-0.4 -0.57)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.35,34.05a3.34,3.34,0,0,1-1.28-1.63,8.39,8.39,0,0,1-.41-2.9V12l6.57,0V9.73h-6.57V1h-2.33V9.77h-4.5V12l4.58,0V29.52A8.38,8.38,0,0,0,142,33.6a5.19,5.19,0,0,0,2,2.22,6.82,6.82,0,0,0,2.87.89,5.23,5.23,0,0,0,1.5,0v-2a7.15,7.15,0,0,1-1,0A4.7,4.7,0,0,1,145.35,34.05Z",
    transform: "translate(-0.4 -0.57)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefactoLogo);
export default __webpack_public_path__ + "static/media/defacto-logo.cef993dd50e14b39ed2b20110cfac3ce.svg";
export { ForwardRef as ReactComponent };